var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"col-md order-1 order-sm-1 order-md-2 order-lg-2"},[_c('div',{staticClass:"row margenes"},[_c('div',{staticClass:"sec_imagen"},[_c('img',{attrs:{"src":require(`@/assets/imagenes/${_vm.imgSrc}`),"alt":_vm.imgAlt}})])])])
}
var staticRenderFns = []

export { render, staticRenderFns }